import { axiosBeelineRequest } from '@beef/utils';
import { CTN_STATUS } from "../endpoints";
export var checkBeelineRequest = function checkBeelineRequest(baseUrl, ctn) {
  return axiosBeelineRequest({
    url: "".concat(baseUrl).concat(CTN_STATUS),
    params: {
      ctn: ctn,
      userType: 0
    }
  }).then(function (resp) {
    return resp && resp.CtnStatus !== 2;
  });
};